import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { MissingSeatsAndPermissionsList } from '../components/internal/Shared/MissingSeatsAndPermissionsList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function buildAccessCheckTooltipTitle(accessInfo, taskDescription, contentOverride) {
  if (contentOverride) {
    return contentOverride;
  }
  const totalMissingItems = accessInfo.missingPermissions.length + accessInfo.missingSeats.length;
  if (totalMissingItems > 1) {
    return /*#__PURE__*/_jsxs(TFlex, {
      flexDirection: "column",
      gap: 4,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "access-check-lib.accessCheck.messaging.tooltip.requiredMultiplePermissions",
        options: {
          taskDescription
        }
      }), /*#__PURE__*/_jsx(MissingSeatsAndPermissionsList, {
        accessInfo: accessInfo,
        listItemMarginStyleProps: {
          marginBlockStart: '100'
        }
      })]
    });
  }
  if (totalMissingItems === 1) {
    var _accessInfo$missingPe;
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "access-check-lib.accessCheck.messaging.requiredSinglePermission",
      options: {
        permissionName: (_accessInfo$missingPe = accessInfo.missingPermissions[0]) !== null && _accessInfo$missingPe !== void 0 ? _accessInfo$missingPe : accessInfo.missingSeats[0],
        taskDescription
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "access-check-lib.accessCheck.messaging.missingPermissionName",
    options: {
      taskDescription
    }
  });
}